import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import type { TSelectedProductType } from 'shared/types/TCustomerService';

export const KNOWN_PRODUCT_TYPE_VALUES: TSelectedProductType[] = [
  PRODUCT_TYPES_VALUES.CREDIT,
  PRODUCT_TYPES_VALUES.CREDIT_CARD,
  PRODUCT_TYPES_VALUES.MICRO_CREDIT,
];

export const isKnownProductTypeValue = (value: unknown): value is TSelectedProductType =>
  typeof value === 'string' && KNOWN_PRODUCT_TYPE_VALUES.includes(value as TSelectedProductType);
